import * as React from 'react';
import * as Styled from './Steps.styles';
import Text from '@ids/components/Typography/Text';
import { NormalizedLandingPageData } from '@ids/context/LandingPage/types';
import Media from '@ids/components/Media';

type DataAttributes = {
    'data-position': string;
    'data-step': string;
    'data-last-step'?: boolean;
};

const getDataAttributes = (stepsCount: number, index: number): DataAttributes => {
    const dataAttributes = {} as DataAttributes;

    dataAttributes['data-position'] = index % 2 ? 'odd' : 'even';
    dataAttributes['data-step'] = `${index + 1}-${stepsCount}`;

    if (stepsCount === index + 1) {
        dataAttributes['data-last-step'] = true;
    }

    return dataAttributes;
};

export interface StepsProps {
    steps: NormalizedLandingPageData['howItWorksBlock']['stepItems'];
}

const Steps = ({ steps }: StepsProps) => {
    return (
        <Styled.Steps>
            {steps.map(({ title, contentText, idsMedia }, index) => {
                return (
                    <Styled.Step key={title} {...getDataAttributes(steps.length, index)}>
                        <Styled.MediaWrapper ratio={4 / 3}>
                            <Media media={idsMedia} image={{ sizes: '(max-width: 767px) 100vw, 40vw' }} />
                        </Styled.MediaWrapper>
                        <Styled.PathContainer>
                            <Styled.TextPath>
                                <Text as="h3" variant="subtitle">
                                    {title}
                                </Text>
                                <Text>{contentText}</Text>
                            </Styled.TextPath>
                            <Styled.NoTextPath />
                        </Styled.PathContainer>
                    </Styled.Step>
                );
            })}
        </Styled.Steps>
    );
};

export default Steps;
